export default __webpack_public_path__ + "static/media/Blade's Belt of Charred Earth.89e8e121.jpg";